export default __webpack_public_path__ + "static/char-s-02-chs-abb3eb13f1d4af550c34aee542b6209c.png";